import React from 'react'
import { Route } from 'react-router-dom'

import Routes from 'commons/js/routes/routes'

import BookingAvailabilityContainer from 'parking-availability/js/containers'

class BookingAvailability extends React.Component {
    render () {
        return (
            <Route
              path={Routes.parkingPath()}
              component={BookingAvailabilityContainer}
            />
        )
    }
}

export default BookingAvailability
